import { useContext, useEffect, useRef, useState } from "react";
import { MinusCircleOutlined } from "@ant-design/icons";
import { Form, Modal, Popover, Select, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  setOrganisationType as localStorageSetOrganisationType,
  setSector as localStorageSetSector,
  setSubSector as localStorageSetSubSector,
  setInterestAndAssetType,
  setSize,
  setTabValue,
  updateOrganisationNameById,
} from "../../Reducer/localStorageSlice";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import closeIcon from "../../assets/newImages/ProfileClose.svg";
import {
  FilterSlider,
  Filter as IconFilter,

} from "../../components/Icons/Icons";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import { GlobalContext } from "../../components/globalContext/GlobalContext";
import OrganiationSizes from "../../json/organizationSize.json";
import { handleErrorMessage } from "../../utils/helper";

import poweredByLogo from "../../assets/images/powered_by_datacity_light.png";

import "./filter.scss";
import { enumAndLabelAdapter } from "../../utils/util";

const interest = [
  "",
  "PRODUCT",
  "SERVICE",
  "CONTRACTS",
  "VACANCY",
  "APPRENTICESHIP",
  "WORK_EXPERIENCE",
  "COURSES",
];

function Filter({
  setOrganisationNameById,
  setData,
  updateFilterData,
  currentOrganisationType,
  masterDataIds
}) {
  const dispatch = useDispatch();
  const localData = useSelector((state) => state?.localStorage);
  const {
    partner,
    partnerId,
    sector: sectorValue,
    searchName,
    size: localDataSize,
    subSector: subSectorValue,
    OrganisationType,
  } = localData;

  const [form] = Form.useForm();
  const filtersPopUp = useRef(null);
  const { globalState } = useContext(GlobalContext);

  const [openFilter, setOpenFilter] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  // list of sectors and sub sectors from api call
  const [sectors, setSectors] = useState([]);
  const [subSectors, setSubSectors] = useState([]);

  const [selectedOrganisationType, setSelectedOrganisationType] = useState(
    OrganisationType || ""
  );
  const [selectedInterest, setSelectedInterest] = useState(
    localData["Interest/AssetType"] || ""
  );

  const [selectedSector, setSelectedSector] = useState(sectorValue || "");
  const [selectedSubSector, setSelectedSubSector] = useState(
    subSectorValue || ""
  );

  const [organisationType, setOrganisationType] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localData?.sector) {
      sectorChange(localData?.sector);
    }
    setSelectedInterest(localData["Interest/AssetType"] || "");
    setSelectedOrganisationType(localData?.OrganisationType);
    setSizeValue(localData?.size);
    setSelectedSector(localData?.sector);
    setSelectedSubSector(localData?.subSector);
  }, [localData]);

  const [sizeValue, setSizeValue] = useState(localDataSize || "");

  const [organisationTypeName, setOrganisationTypeName] = useState(
    () => OrganisationType || null
  );

  let sectorId = localData.sector;
  let size = localDataSize;

  let search = searchName;

  const getOnOrganisationType = async (partnerId) => {
    try {
      const response = await getRequest(
        userapiservice.getOnOrganisationType(partnerId)
      );
      if (response) {
        setOrganisationType(response);
      }
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={handleErrorMessage(
            error,
            "Failed to fetch organisation type"
          )}
        />
      );
    }
  };

  const fetchSectorList = async (partnerId) => {
    try {
      const response = await getRequest(
        userapiservice.getAllSectors(partnerId)
      );
      setSectors(response);
      if (sectorId) {
        sectorChange(sectorId);
      }
      if (size) {
        setSizeValue(size);
      }
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={handleErrorMessage(error, "Failed to fetch sector list")}
        />
      );
    }
  };

  const sectorChange = async (sectorId) => {
    setSelectedSector(sectorId);
    if (sectorId) {
      try {
        setSelectedSubSector("");
        setLoading(true);
        const response = await getRequest(
          // userapiservice.getSubSectors(sectorId)
          userapiservice.getSubSectorsForFilter(sectorId)
        );
        setSubSectors(response);
        // if (!localData?.sector) {
        //   setSelectedSubSector("");
        // }
      } catch (error) {
        toast.error(
          <ToastComponent
            type={"Error"}
            message={handleErrorMessage(error, "Failed to fetch sub-sectors")}
          />
        );
      } finally {
        setLoading(false);
      }
    } else {
      setSelectedSubSector(null);
      setSubSectors(null);
    }
  };

  const subSectorChange = async (subSectorIds, i) => {
    setSelectedSubSector(subSectorIds);
  };

  const SizeChange = async (size) => {
    setSizeValue(size);
  };

  const filterMicrosites = async (
    partner,
    organisationType,
    interest,
    sectorId,
    subSectorIds,
    size,
    search
  ) => {
    try {
      setConfirmLoading(true);
      let response;

      const masterDataValue = enumAndLabelAdapter(interest)
      const masterDataId = masterDataIds?.find((m)=>m?.value===masterDataValue)?.id
      if(interest){
        if(!masterDataId) return
      }
      response = await getRequest(
        userapiservice.filterMicrosites(
          partner,
          organisationType,
          interest,
          sectorId,
          subSectorIds,
          size,
          search,
          null,
          null,
          null,
          null,
          masterDataId
        )
      );
      setData(
        response.result,
        organisationType,
        interest,
        sectorId,
        subSectorIds,
        size
      );
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={handleErrorMessage(error, "Failed to filter microsites")}
        />
      );
    } finally {
      setConfirmLoading(false);
    }
  };

  const handleOk = () => {
    setOpenFilter(false);
    dispatch(localStorageSetOrganisationType(selectedOrganisationType));
    dispatch(setInterestAndAssetType(selectedInterest));
    dispatch(localStorageSetSector(selectedSector));
    dispatch(localStorageSetSubSector(selectedSubSector));
    dispatch(setSize(sizeValue || ""));

    const name = organisationType?.find(
      (type) => type?.id === selectedOrganisationType
    )?.displayName;
    setOrganisationNameById(name);

    let tabValue = "";
    switch (selectedInterest) {
      case "PRODUCT":
        tabValue = "product";
        break;
      case "SERVICE":
        tabValue = "service";
        break;
      case "CONTRACTS":
        tabValue = "contract";
        break;
      case "VACANCY":
        tabValue = "vacancy";
        break;
      case "APPRENTICESHIP":
        tabValue = "apprenticeship";
        break;
      case "COURSES":
        tabValue = "courses";
        break;
      default:
        tabValue = "work-experience";
    }
    dispatch(setTabValue(tabValue));

    // filterMicrosites(
    //   partner,
    //   selectedOrganisationType,
    //   selectedInterest,
    //   sectorValue,
    //   subSectorValue,
    //   sizeValue,
    //   search
    // );

    filterMicrosites(
      partner,
      selectedOrganisationType,
      selectedInterest,
      selectedSector,
      selectedSubSector,
      sizeValue,
      search
    );
  };

  const handleCancel = () => {
    setOpenFilter(false);
  };

  const handleCross = () => {
    setSubSectors([]);

    dispatch(localStorageSetOrganisationType(""));
    dispatch(setInterestAndAssetType(""));
    dispatch(localStorageSetSector(""));
    dispatch(localStorageSetSubSector(""));
    dispatch(setSize(""));
    dispatch(setTabValue(""));
    handleCancel();
  };

  const onChangeOrgType = (value) => {
    setSelectedOrganisationType(value);
  };

  const deleteSelectedValue = (variableName) => {
    if (variableName === "interest") {
      setSelectedInterest(null);

      dispatch(setInterestAndAssetType(""));
      dispatch(setTabValue(""));
    }
    if (variableName === "organisationType") {
      setSelectedOrganisationType(null);
      setOrganisationTypeName(null);
      dispatch(setOrganisationType(""));
      dispatch(updateOrganisationNameById(""));
    }
    if (variableName === "sector") {
      setSubSectors(null);
      setSelectedSector("");
      setSelectedSubSector(null);
    }
    if (variableName === "subsector") {
      setSelectedSubSector("");
    }
    if (variableName === "size") {
      setSizeValue(null);
      dispatch(setSize(""));
    }
  };

  const FilterForm = () => {
    return (
      <Form form={form} className="p-0 profile-filters-form ">
        <Form.List name="sectorsOutputs">
          {(fields, i) => (
            <div className="row p-md-2 pb-md-0 p-lg-3 pb-lg-0">
              <Form.Item className="col-12 col-lg-6 form-item">
                <label className="label-text">Search organisations for</label>
                <Select
                  placeholder="Select Option"
                  value={selectedInterest || "All"}
                  onChange={(e) => {
                    setSelectedInterest(e);
                  }}
                >
                  {interest?.map((Search, i) => (
                    <Select.Option key={i} value={interest[i]}>
                      {interest[i] === ""
                        ? "All"
                        : interest[i] === "APPRENTICESHIP"
                          ? "Apprenticeships"
                          : interest[i] === "VACANCY"
                            ? "Vacancies"
                            : interest[i] === "PRODUCT"
                              ? "Products"
                              : interest[i] === "CONTRACTS"
                                ? "Contracts"
                                : interest[i] === "SERVICE"
                                  ? "Services"
                                  : interest[i] === "WORK_EXPERIENCE"
                                    ? "Experiences of work"
                                    : interest[i] === "COURSES"
                                      ? "Courses"
                                      : interest[i] === "CONTRACTS"
                                        ? "Contracts"
                                        : ""}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item className="col-12 col-lg-6 form-item">
                <label className="label-text">Organisation Type</label>
                <Select
                  placeholder="Select Option"
                  value={
                    organisationType?.find(
                      (type) => type.id === selectedOrganisationType
                    )?.displayName || "All"
                  }
                  onChange={(e) => onChangeOrgType(e)}
                // form={form}
                >
                  {organisationType?.map((type, i) => (
                    <Select.Option key={i} value={type?.id}>
                      {type?.type === "" ? "All" : type?.displayName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item className="col-12 col-lg-6 form-item">
                <div className="label-with-logo">
                  <label>Categories</label>
                  <img
                    src={poweredByLogo}
                    alt="Powered by Datacity"
                    className="powered-logo"
                  />
                </div>
                <Select
                  value={selectedSector}
                  onChange={(e) => sectorChange(e, i)}
                >
                  <Select.Option value="">All</Select.Option>
                  {sectors?.map((Sector, i) => (
                    <Select.Option key={i} value={Sector.id}>
                      {Sector.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item className="col-12 col-lg-6 form-item">
                <div className="label-with-logo">
                  <label>Sub Categories</label>
                  <img
                    src={poweredByLogo}
                    alt="Powered by Datacity"
                    className="powered-logo"
                  />
                </div>
                <Select
                  value={selectedSubSector}
                  onChange={(e) => subSectorChange(e, i)}
                  loading={loading}
                  disabled={!selectedSector}

                >
                  <Select.Option value="">All</Select.Option>
                  {subSectors &&
                    subSectors?.map((subSector, i) => (
                      <Select.Option key={i} value={subSector.id}>
                        {subSector.name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item className="col-12 col-lg-6 form-item">
                <label className="label-text">Size by employees</label>
                <Select value={sizeValue} onChange={(e) => SizeChange(e, i)}>
                  <Select.Option value="">All</Select.Option>
                  {OrganiationSizes.map((OrganiationSize, i) => (
                    <Select.Option key={i} value={OrganiationSize.id}>
                      {OrganiationSize.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          )}
        </Form.List>
      </Form>
    );
  };

  useEffect(() => {
    if (partnerId) {
      getOnOrganisationType(partnerId);
      fetchSectorList(partnerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerId]);

  useEffect(() => {
    setOrganisationTypeName(organisationType);
    setSizeValue(localDataSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateFilterData]);

  useEffect(() => {
    form.setFieldsValue({
      organisationType: selectedOrganisationType || "All",
      interests: selectedInterest || "All",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganisationType, selectedInterest]);

  return (
    <div className="microsite-listing-filter-container">
      <Popover
        destroyTooltipOnHide
        trigger="click"
        placement="topLeft"
        open={!globalState.isMobile && openFilter}
        onOpenChange={() => {
          setOpenFilter(!openFilter);
        }}
        content={
          <div
            ref={filtersPopUp}
            className="microsite-listing-page-filters-popup"
          >
            <FilterForm />
            <div className="filters-submit-btn-container p-md-2 p-lg-3 pt-0">
              <button
                className="btn btn-primary filters-submit-btn"
                onClick={handleOk}
              >
                Filter Results
              </button>
            </div>
          </div>
        }
      >
        <button
          className="button-wrapper"
          type="button"
          onClick={() => {
            setOpenFilter(true);
          }}
        >
          <FilterSlider />
        </button>
      </Popover>
      {globalState.isMobile && openFilter && (
        <Modal
          destroyOnClose
          title={
            <div className="microsite-filter-title">
              {/* <IconFilter /> */}
              <FilterSlider />
            </div>
          }
          open={openFilter}
          confirmLoading={confirmLoading}
          closeIcon={
            <img
              className="closeIcon"
              style={{ width: "14px", top: "15px", paddingTop: "5px" }}
              src={closeIcon}
              onClick={handleCross}
              alt="close"
            />
          }
          okText="Filter Results"
          className="microsite-filter-modal-container"
          footer={false}
        >
          <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <FilterForm />
            <div className="d-flex justify-content-center gap-3 p-md-2 p-lg-3 pt-0">
              <button className="btn btn-secondary " onClick={handleCancel}>
                Cancel
              </button>
              <button
                className="btn btn-primary filters-submit-btn"
                onClick={handleOk}
              >
                Filter Results
              </button>
            </div>
          </Space>
        </Modal>
      )}
    </div>
  );
}

export default Filter;
